/**
 * Amada 分期付款页 / AMADA SHOP PAY
 * ----------------------------------------------------------------------
 * 本文件被 layout/theme.liquid 全局挂载（每页都加载，defer 执行）——
 * 必须先判断本页是否存在 [data-amada-paylater]，不存在就立即返回，
 * 不能假设"反正只有分期付款页才有这段 DOM"（CLAUDE.md 铁律 + 项目审计结论）。
 *
 * 两个独立小模块：
 *   1. FAQ 手风琴：点击问题切换对应答案的 hidden 属性，多条可同时展开（非互斥）。
 *   2. 分期计算器：输入金额 + 选择"Pay in 4" / "Monthly installments"，
 *      前端按 section settings 里配置的期数/年利率纯前端计算展示，
 *      不接任何第三方 API（Figma 稿未画计算结果区，这部分是按钮+输入框
 *      之外必要新增的功能 UI，规则来自 section settings，非硬编码业务规则）。
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-amada-paylater]');
  if (!root) return;

  /* ---------------------------------------------------------------------
   * 1. FAQ 手风琴
   * ------------------------------------------------------------------- */
  var faqRoot = root.querySelector('[data-paylater-faq]');
  if (faqRoot) {
    faqRoot.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-paylater-faq-toggle]');
      if (!toggle || !faqRoot.contains(toggle)) return;

      var item = toggle.closest('.amada-paylater__faq-item');
      var answer = item && item.querySelector('[data-paylater-faq-answer]');
      if (!answer) return;

      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      answer.hidden = isExpanded;
    });
  }

  /* ---------------------------------------------------------------------
   * 2. 分期计算器
   * ------------------------------------------------------------------- */
  var calc = root.querySelector('[data-paylater-calculator]');
  if (!calc) return;

  var amountInput = calc.querySelector('[data-paylater-amount]');
  var tabButtons = calc.querySelectorAll('[data-paylater-tab]');
  var resultBox = calc.querySelector('[data-paylater-result]');
  var pay4Line = calc.querySelector('[data-paylater-result-pay4]');
  var monthlyList = calc.querySelector('[data-paylater-result-monthly]');
  var emptyLine = calc.querySelector('[data-paylater-result-empty]');
  var planItems = calc.querySelectorAll('.amada-paylater__calc-plan');

  var currencySymbol = calc.getAttribute('data-currency-symbol') || '$';
  var option1Count = parseFloat(calc.getAttribute('data-option1-count')) || 4;
  var option1Apr = parseFloat(calc.getAttribute('data-option1-apr')) || 0;

  var activeTab = 'pay4';

  function formatMoney(amount) {
    var value = Math.max(0, amount || 0);
    return currencySymbol + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // A-20：原来 replace(/[^0-9.]/g,'') 会把负号一起剥掉，粘贴 "-5" 被当成 5，
  // 算出 "6 monthly payments of $0.83"。这里保留最前面的负号，
  // 负数与 0 一样交给 render() 的 amount <= 0 分支回落空态。
  function parseAmount(raw) {
    if (!raw) return NaN;
    var trimmed = String(raw).trim();
    var negative = /^\s*[-\u2212]/.test(trimmed); // 半角减号与 Unicode 减号都算
    var cleaned = trimmed.replace(/[^0-9.]/g, '');
    if (cleaned === '') return NaN;
    var value = parseFloat(cleaned);
    if (isNaN(value)) return NaN;
    return negative ? -value : value;
  }

  // 简单利率试算：月供 = 总额 × (1 + 年利率% × 期数/12) ÷ 期数。
  // 默认年利率均为 0%，此时就是总额直接均分——真实上线若接入 Shop Pay
  // Installments / Affirm 官方费率表，替换本函数即可，UI 不需要改动。
  function computeInstallment(total, count, aprPercent) {
    if (!count) return 0;
    var interestFactor = 1 + (aprPercent / 100) * (count / 12);
    return (total * interestFactor) / count;
  }

  function setTab(tab) {
    activeTab = tab;
    tabButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-paylater-tab') === tab;
      btn.classList.toggle('is-selected', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    render();
  }

  function render() {
    var amount = parseAmount(amountInput ? amountInput.value : '');

    if (!resultBox) return;

    if (isNaN(amount) || amount <= 0) {
      resultBox.hidden = true;
      if (pay4Line) pay4Line.hidden = true;
      if (monthlyList) monthlyList.hidden = true;
      if (emptyLine) emptyLine.hidden = true;
      return;
    }

    resultBox.hidden = false;
    if (emptyLine) emptyLine.hidden = true;

    if (activeTab === 'pay4') {
      if (monthlyList) monthlyList.hidden = true;
      if (pay4Line) {
        pay4Line.hidden = false;
        var perPayment = computeInstallment(amount, option1Count, option1Apr);
        var aprText = option1Apr > 0 ? (option1Apr + '% APR') : '0% APR';
        pay4Line.textContent = option1Count + ' payments of ' + formatMoney(perPayment) + ', ' + aprText;
      }
    } else {
      if (pay4Line) pay4Line.hidden = true;
      if (monthlyList) {
        monthlyList.hidden = planItems.length === 0;
        planItems.forEach(function (item) {
          var months = parseFloat(item.getAttribute('data-months')) || 0;
          var apr = parseFloat(item.getAttribute('data-apr')) || 0;
          var textEl = item.querySelector('[data-paylater-plan-text]');
          if (!textEl || !months) return;
          var perPayment = computeInstallment(amount, months, apr);
          var aprText = apr > 0 ? (apr + '% APR') : '0% APR';
          textEl.textContent = months + ' monthly payments of ' + formatMoney(perPayment) + ', ' + aprText;
        });
      }
    }
  }

  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTab(btn.getAttribute('data-paylater-tab'));
    });
  });

  if (amountInput) {
    amountInput.addEventListener('input', render);
  }

  // 初始态严格沿用 Figma：未输入金额时结果区保持隐藏；有有效金额后才显示试算。
  render();
})();
